<template>
  <component
    :is="QUESTION_TYPES[state.question?.questionValue?.type]"
    v-model="state.question"
  />
</template>

<script>
import { reactive, computed } from 'vue';
import HrShortQuestion from '@/components/hr-short-answer-questions.vue';
import HrMultipleQuestion from '@/components/hr-multiple-choice-questions.vue';
import HrYesNoQuestion from '@/components/hr-yes-no-questions.vue';
// add more types of questions to cater specific fields
const QUESTION_TYPES = {
  SHORT: HrShortQuestion,
  MULTIPLE: HrMultipleQuestion,
  YES_NO: HrYesNoQuestion,
};
export default {
  name: 'hr-question-factory',
  components: {
    HrShortQuestion,
    HrMultipleQuestion,
    HrYesNoQuestion,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value'],
  setup(props, { emit }) {
    const state = reactive({
      question: computed({
        get: () => props.modelValue,
        set: (val) => {
          emit('update:model-value', { ...val });
        },
      }),
    });

    return {
      state,
      QUESTION_TYPES,
    };
  },
};
</script>
